/**
 * Gamification API (me, user summary, leaderboards).
 */

import apiClient from './api-client';
import type {
  GamificationSummary,
  LeaderboardResponse,
  EstablishmentLeaderboardResponse,
  LeaderboardQueryParams,
} from '@/types/gamification.types';

/** `GET /gamification/users/:userId` — staff summary for a tutor/volunteer. */
export async function fetchGamificationForUser(userId: string): Promise<GamificationSummary> {
  const { data } = await apiClient.get<GamificationSummary>(`/gamification/users/${userId}`);
  return data;
}

/** `GET /gamification/leaderboard` */
export async function fetchLeaderboard(
  params: LeaderboardQueryParams = {},
): Promise<LeaderboardResponse> {
  const { data } = await apiClient.get<LeaderboardResponse>('/gamification/leaderboard', {
    params: {
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 20,
      search: params.search?.trim() || undefined,
    },
  });
  return {
    entries: data.entries ?? [],
    total: data.total ?? 0,
    page: data.page ?? 1,
    pageSize: data.pageSize ?? 20,
    myRank: data.myRank ?? 0,
    myEntry: data.myEntry ?? null,
  };
}

/** `GET /gamification/leaderboard/establishments` */
export async function fetchEstablishmentLeaderboard(
  params: LeaderboardQueryParams = {},
): Promise<EstablishmentLeaderboardResponse> {
  const { data } = await apiClient.get<EstablishmentLeaderboardResponse>(
    '/gamification/leaderboard/establishments',
    {
      params: {
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 20,
        search: params.search?.trim() || undefined,
      },
    },
  );
  return {
    entries: data.entries ?? [],
    total: data.total ?? 0,
    page: data.page ?? 1,
    pageSize: data.pageSize ?? 20,
    myRank: data.myRank ?? 0,
    myEntry: data.myEntry ?? null,
  };
}
